import {useUp} from 'quickstart/styled-components/system'
import {ComponentProps} from 'react'
import {Box} from '../Box'

type SidebarProps = ComponentProps<typeof Box>

export const Sidebar = (props: SidebarProps) =>
  useUp('lg') ? <Box col={0.25} mr="2rem" {...props} /> : null
